import { lazy, Suspense } from 'react';
import RedirectIfAuthenticated from '../components/AuthGuards/RedirectIfAuthenticated';

const LoginPage = lazy(() => import('../pages/Auth/LoginPage'));
const RecoverPage = lazy(() => import('../pages/Auth/RecoverPage'));
const RegisterPage = lazy(() => import('../pages/Auth/RegisterPage'));
const ResetPage = lazy(() => import('../pages/Auth/ResetPage'));

export const AuthRoutes = [
  {
    path: 'sign-in',
    element: (
      <Suspense fallback={<></>}>
        <RedirectIfAuthenticated>
          <LoginPage />
        </RedirectIfAuthenticated>
      </Suspense>
    ),
  },
  {
    path: 'sign-up',
    // A signed-in account has nothing to do here (27 Oct, step 6), as on sign-in.
    element: (
      <Suspense fallback={<></>}>
        <RedirectIfAuthenticated>
          <RegisterPage />
        </RedirectIfAuthenticated>
      </Suspense>
    ),
  },
  {
    path: 'recover-customer',
    element: (
      <Suspense fallback={<></>}>
        <RecoverPage />
      </Suspense>
    ),
  },
  {
    path: 'reset-customer-password',
    element: (
      <Suspense fallback={<></>}>
        <ResetPage />
      </Suspense>
    ),
  },
];
